import {useDevelopment} from './data/use-development'
import styles from './Development.module.css'
import {LinkedIssues} from './LinkedIssues'
import {UserSectionSkeleton} from './UserSectionSkeleton'
import sidebarListStyles from './SidebarActionList.module.css'

export function Development() {
  const {data, isPending, isError} = useDevelopment()

  if (isPending && !data) return <UserSectionSkeleton placeholderRows={1} />

  if (isError && !data) {
    return <span className={sidebarListStyles.emptyState}>Unable to load development</span>
  }

  const {linkedIssues} = data

  return linkedIssues.length === 0 ? (
    <span className={sidebarListStyles.emptyState}>No linked issues</span>
  ) : (
    <>
      <span className={styles.helpText}>Merging this pull request may close these issues.</span>
      <LinkedIssues linkedIssues={linkedIssues} />
    </>
  )
}
